import FirebaseModel from "./firebasemodel";
export default class PhotoTag extends FirebaseModel {
    constructor(_model) {
        super(_model);
        // this.name = this.data.name;
    }
}
